export default __webpack_public_path__ + "static/media/avisodeprivacidad.c4c89fb8.pdf";